// extracted by mini-css-extract-plugin
module.exports = {"orderLink":"styles_orderLink__GgTl1","orderTimeLabel":"styles_orderTimeLabel__75Y8B","orderItem":"styles_orderItem__Tf05t"};